// The shell every study-tools card shares: a small caps heading, and — for the
// three that follow the reader down the page — the verse they are about.
export function RailCard({
  title,
  verse,
  children,
}: {
  title: string;
  /** "Nehemiah 1:3", when the card is about one verse. */
  verse?: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <h2 className="mb-3 flex items-baseline gap-2 font-sans text-[11px] tracking-[0.1em] text-ink-3 uppercase">
        {title}
        {verse && <span className="truncate font-serif text-[12px] tracking-normal text-accent normal-case">{verse}</span>}
      </h2>
      {children}
    </div>
  );
}
